import * as React from "react";
import { useStateStore } from "../../store";
import Header from "./Header";
import TaskPane from "./TaskPane";
import { Button, makeStyles, tokens, Spinner, Link } from "@fluentui/react-components";
import HeroList, { HeroListItem } from "./HeroList";
import { ArrowSyncRegular, MailAddRegular, PeopleAddRegular } from "@fluentui/react-icons";
import Toolbar from "./Toolbar";
import { t } from "../../utils/translations";
import { useEffect, useState } from "react";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    height: "100%",
    backgroundColor: tokens.colorNeutralBackground1,
  },
  firstRunContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    marginBottom: "30px",
  },
});


const App = () => {
  const styles = useStyles();
  const { firstRun, setFirstRun, initialize } = useStateStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeAsyncData = async () => {
      try {
        await initialize();
      } catch (error) {
        console.error("Error al inicializar datos del store", error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeAsyncData();
  }, [initialize]);

  if (isLoading) {
    // Mostrar un loader/spinner mientras los datos están cargando
    return (
      <div style={style.container}>
        <Spinner labelPosition="below" label="Cargando..." />
      </div>
    );
  }

  const handleStartClick = () => {
    setFirstRun(false);
  };

  const listItems: HeroListItem[] = [
    {
      icon: <MailAddRegular />,
      primaryText: t("firstRunPrimaryText1"),
      seccondaryText: t("firstRunSecondaryText1"),
    },
    {
      icon: <ArrowSyncRegular />,
      primaryText: t("firstRunPrimaryText2"),
      seccondaryText: t("firstRunSecondaryText2"),
    },
    {
      icon: <PeopleAddRegular />,
      primaryText: t("firstRunPrimaryText3"),
      seccondaryText: t("firstRunSecondaryText3"),
    },
  ];

  const message = t("welcomeMessage");

  return (
    <div className={styles.root}>
      {firstRun ? (
        <>
          <Header logo="assets/logo-filled.png" title="Tu Aplicación" message="Knowee" />
          <div className={styles.firstRunContainer}>
            <HeroList message={message} items={listItems} />
            <p>
              {t("createAccountMessage")}
              <Link href="https://www.know.ee/register/registration/new" target="_blank" rel="noopener noreferrer">
                {t("createHere")}
              </Link>
              {t("createAccountMessage2")}
            </p>
            <Button appearance="primary" disabled={false} size="large" onClick={handleStartClick}>
              {t("startButton")}
            </Button>
          </div>
        </>
      ) : (
        <>
          <TaskPane />
          <Toolbar />
        </>
      )}
    </div>
  );
};

const style = {
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default App;
